import { MilestoneConfigurationType } from 'types/cashFlow'

// a list of countries that allow surcharging generally, but not on debit cards
export const COUNTRIES_WITHOUT_DEBIT_CARD_SURCHARGING = ['US']

export const SURCHARGING_ENABLED_COUNTRIES: readonly string[] = ['US', 'AU', 'CA', 'NZ']

/** Canadian provinces where payment-request surcharging is not permitted. */
export const SURCHARGING_NOT_ALLOWED_CA_PROVINCES: readonly string[] = ['QC']

export const isCaProvinceAllowingSurcharge = (province: string | undefined | null): boolean => {
  if (!province) {
    return true
  }
  const normalized = province.trim().toUpperCase()
  if (normalized === 'QUEBEC') {
    return false
  }
  return !SURCHARGING_NOT_ALLOWED_CA_PROVINCES.includes(normalized)
}

export const INVOICE_STATUS_TOOLTIP_MAP = {
  'Not Sent': 'Invoice has not yet been sent to the customer.',
  Sent: 'Invoice and payment link has been sent to the customer.',
  Viewed: 'Payment link has been viewed by the customer but the payment is not yet complete.',
  'Awaiting Transfer': 'Customer saw the payment instructions but has not yet taken action.',
  Pending: 'Customer authorized the payment, but it has not yet been confirmed.',
  Approved: 'Customer payment was approved and will reach your bank account shortly.',
  'Partially Paid': 'Partial payment was complete and sent to your bank account.',
  Paid: 'Payment has been sent to your bank account.',
  Overdue: 'Payment was not authorized prior to the due date.',
  Cancelled: 'Invoice was cancelled by your team.',
  'Payment Failed':
    'Payment was not successful. Customer has been prompted to retry but you can send the payment link again.',
  'Chargeback pending': 'Customer has initiated chargeback procedure. OpenSolar will be in contact about next steps.',
  'Chargeback complete': 'Chargeback has been processed.',
  'Refund Pending': 'Refund process has been initiated but is not yet complete.',
  Refunded: 'Payment was refunded by your team.',
  'Payment Error':
    'Customer attempted a payment, but an error occurred. Please check if the payment was successful and then either confirm it or mark it as not paid.',
  Other: 'Invoice is in an exception status - reach out to OpenSolar for more information.',
  'Confirmation Required':
    'The customer has notified OpenSolar that they completed this payment. Please use the Actions button to the right to confirm that you have received the payment so it can be marked as completed',
}

export const NEW_MILESTONE_PLACEHOLDER: MilestoneConfigurationType = {
  title: '',
  description: '',
  percentage: undefined,
  min_fixed: undefined,
  max_fixed: undefined,
  set_value_to_remaining_amount_due: true,
  surcharging_enabled: false,
  accepted_payment_methods: [],
  payment_number: undefined,
  is_archived: false,
  payments_configuration: undefined,
  created_date: undefined,
  enable_payment_cta_on_proposal: false,
}

export const US_STATES_FOR_POST_DEPOSIT_DEFAULT_ACH_PAYMENT = ['CT', 'ME', 'MA', 'PR', 'OK']
